module.exports = __webpack_public_path__ + "img/5.5e2a1418.png";